import { jsxs as t, jsx as e } from "react/jsx-runtime";
const a = (h) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1rem", height: "1rem", fill: "none", viewBox: "0 0 32 24", ...h, children: [
  /* @__PURE__ */ e("rect", { width: 31, height: 23, x: 0.5, y: 0.5, fill: "#EAF5FF", stroke: "#B8E1FF", rx: 2.5 }),
  /* @__PURE__ */ e(
    "path",
    {
      fill: "#0C75AF",
      fillRule: "evenodd",
      d: "M19.286 9.286v-.857a.397.397 0 0 0-.138-.302A.465.465 0 0 0 18.82 8h-8.357a.465.465 0 0 0-.326.127.397.397 0 0 0-.138.302v.857c0 .116.046.216.138.301.092.085.2.127.326.127h8.357a.465.465 0 0 0 .327-.127.397.397 0 0 0 .138-.301Zm2.785 2.713v.857a.397.397 0 0 1-.137.301.465.465 0 0 1-.327.128H10.464a.465.465 0 0 1-.326-.128.397.397 0 0 1-.138-.301v-.857c0-.116.046-.217.138-.302a.465.465 0 0 1 .326-.127h11.143c.126 0 .235.043.327.127a.397.397 0 0 1 .137.302Zm-1.857 3.574v.857a.397.397 0 0 1-.137.302.465.465 0 0 1-.327.127h-9.286a.465.465 0 0 1-.326-.127.397.397 0 0 1-.138-.302v-.857c0-.116.046-.216.138-.301a.465.465 0 0 1 .326-.127h9.286c.126 0 .235.042.326.127a.397.397 0 0 1 .138.301Z",
      clipRule: "evenodd"
    }
  )
] }), l = a;
export {
  l as default
};
